<script>
import { fandomBasicMixin } from 'src/modules/fandom_mixins_module.js';
import { get } from 'lodash';

export default {
  mixins: [fandomBasicMixin],
  computed: {
    style() {
      return {
        'background-image': this.getContentResponsiveImageURL('background_image'),
        'background-color': this.content.background_color || 'var(--primary)'
      }
    },
    newsletterRecord() {
      return get(this, ["pageModel", "layout", "content", "newsletter"], false);
    }
  }
};
</script>

<template>
  <div
    :style="style"
    :class="contentType"
    v-easyadmin="easyadminId" 
    page-vbl-premium-component
    v-if="isContentVisibleToUser()" 
  >
    <div class="container">
      <div class="row">
        <div class="col-12 col-md-6 text-white py-5 d-flex align-items-center">
          <text-section :content="content" :opt-container-content="containerContent"/>
        </div>
        <div class="col-12 col-md-6 heading-image" :style="{'background-image': getContentResponsiveImageURL('image')}">
        </div>
      </div>
    </div>
    <div class="container bg-white px-md-5 stripes-container">
      <component
        :is="stripe.layout"
        :content="stripe"
        v-for="stripe in content.stripes"
        :key="stripe.$id"
        :opt-container-content="containerContent"
      ></component>
    </div>
    <stripe-newsletter :background-color="this.content.background_color" v-if="newsletterRecord" :content="newsletterRecord" :opt-container-content="pageModel.layout.content"/>
  </div>
</template>

<style lang="scss">
[page-vbl-premium-component] {
  position: relative;
  background-color: $primary;
  background-position: center top;
  

  &, .bg-contain-bottom {
    background-repeat: no-repeat;
    background-size: contain;
  }

  .bg-contain-bottom {
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center bottom;
  }

  .heading-image {
    padding-bottom: 30%;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: bottom left;

    @include media-breakpoint-down(sm) {
      padding-bottom: 56.25%;
      background-position: bottom center;
    }
  }

  @include media-breakpoint-up(sm) {
    .stripes-container {
      border-radius: 10px;
    }
  }

  @include media-breakpoint-down(sm) {
    .stripes-container {
      max-width: 600px;
    }
  }

    // FIX: only for tablet
  @media (min-width: 576px) and (max-width: 916px) {
    [tile-component] {
      min-height: 550px !important;
    }
  }
}
</style>